import script from "./ItemRanking.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemRanking.vue?vue&type=script&setup=true&lang=js"

import "./ItemRanking.vue?vue&type=style&index=0&id=12893702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12893702"]])

export default __exports__